import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import waveBg from '../../../assets/images/home_screen/wave-bg.svg';
import childClimbing from '../../../assets/images/home_screen/child-climbing.webp';
import momAndBaby from '../../../assets/images/home_screen/mom_and_baby.webp';
import { useMediaQuery } from 'react-responsive';

const TherapeuticServices = () => {
  const isTab = useMediaQuery({ query: '(max-width: 1120px)' });

  const TitleAndDescription = ({ title, description, btnText, linkTo }) => {
    return (
      <div className="flex flex-col gap-4">
        <h2 className="text-[26px] text-white font-bold">{title}</h2>
        <p
          className="text-lg text-white font-light lg:max-w-[450px]"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <Link
          to={linkTo}
          className="inline-block border-2 border-white w-full sm:w-fit px-4 hover:bg-primary hover:border-[#764D99] py-1 rounded-md text-white font-semibold text-lg xl:text-[18px] 3xl:text-[20px] transition-all duration-300 transform hover:scale-105 text-center"
        >
          {btnText}
        </Link>
      </div>
    );
  };

  return (
    <div
      id="our_services"
      className="relative min-w-full h-full bg-gradient-to-r from-[#7F76AF] to-[#C572A7]"
    >
      <div className="absolute -top-[50px] sm:-top-[100px] md:-top-[100px] lg:-top-[150px] xl:-top-[180px] 2xl:-top-[220px] 3xl:-top-[250px] 4xl:-top-[280px] 5xl:-top-[350px] left-0 max-w-screen overflow-hidden">
        <img
          src={waveBg}
          alt="wavy-svg-bg"
          className="w-[101vw] h-auto object-fill z-0"
        />
      </div>
      <main className="max-w-[1200px] mx-auto h-full px-4 md:px-10 pt-8 md:pt-24 xl:pt-28 3xl:pt-36 z-10">
        <h2 className="text-[38px] md:text-[52px] text-white font-bold mb-4 md:mb-8">
          Therapeutic Services
        </h2>
        <div className="flex flex-col gap-10">
          <div className="flex flex-col md:flex-row gap-10 md:gap-20">
            <div className="flex-1">
              <TitleAndDescription
                title="Pediatric Physical Therapy"
                btnText="Learn more about PT"
                linkTo="/services"
                description={`
            Pediatric physical therapy  (PT) is about more than just movement; it's about <span class='font-semibold'>empowering children to engage fully in life's adventures</span>. Our skilled therapists work with children to enhance their motor skills, balance, and coordination through fun, tailored activities, ensuring they can leap, run, and play with confidence. Addressing a spectrum of conditions from developmental delays to genetic disorders, our approach not only helps in overcoming physical challenges but also in building a foundation for lifelong physical well-being.
            `}
              />
              <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 2, ease: 'easeInOut' }}
                viewport={{ once: true, amount: 0.5 }}
              >
                <img
                  src={childClimbing}
                  alt="Pediatric physical therapy climbing activity for strength and coordination"
                  loading="lazy"
                  className="min-w-screen md:hidden mt-4"
                />
              </motion.div>
            </div>
            <div className="flex-1">
              <TitleAndDescription
                btnText="Learn more about ST"
                title="Pediatric Speech Therapy"
                linkTo="/services"
                description={`
            Pediatric speech therapy (ST) at Guidepost is <span class='font-semibold'>dedicated to enhancing every child's ability to communicate</span>, from their first words to fluent expressions. Our expert therapists address a myriad of speech and language challenges, from articulation issues to social communication disorders, through engaging, tailored interventions. By empowering children with the right communication tools, we help boost their confidence and interaction skills, paving the way for academic and social success.

            `}
              />
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-10 md:gap-20 md:min-h-[700px] xl:min-h-[730px]">
            <div className="flex-1">
              <div className="relative flex flex-col gap-4 h-[650px]">
                <TitleAndDescription
                  title="Pediatric Occupational Therapy "
                  btnText="Learn more about OT"
                  linkTo="/services"
                  description={`
                Pediatric occupational therapy at Guidepost is dedicated to helping children overcome various developmental hurdles by <span class='font-semibold'>enhancing their physical, cognitive, and social skills through engaging, play-based activities.</span> Our specialized approach not only targets areas like motor skills and sensory processing but also fosters independence, preparing children for success in everyday tasks and interactions.
                `}
                />
                <motion.div
                  initial={{ opacity: 0, x: isTab ? 0 : -300 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.75, ease: 'easeInOut' }}
                  viewport={{ once: true, amount: 0.5 }}
                  className="hidden xl:block"
                >
                  <div className="md:relative md:bottom-4 md:right-0">
                    <img
                      src={momAndBaby}
                      alt="Therapist guiding toddler during play-based therapy session"
                      className="object-contain md:max-w-[450px] xl:max-w-[447px]"
                    />
                  </div>
                </motion.div>
                <img
                  src={momAndBaby}
                  alt="Therapist guiding toddler during play-based therapy session"
                  className="max-w-[80%] object-contain sm:max-w-[75%] xl:hidden block"
                />
              </div>
            </div>
            <div className="flex-1 relative">
              <div className="hidden md:block absolute bottom-0 -right-8 xl:right-14 overflow-hidden">
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 0.75, ease: 'easeInOut' }}
                  viewport={{ once: true, amount: 0.5 }}
                >
                  <img
                    src={childClimbing}
                    alt="Pediatric physical therapy climbing activity for strength and coordination"
                    className="lg:min-w-[571px] min-w-[510px]"
                  />
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TherapeuticServices;
